import { render, staticRenderFns } from "./ReferralAdditionalInfo.vue?vue&type=template&id=30174f2e&scoped=true"
import script from "./ReferralAdditionalInfo.vue?vue&type=script&lang=js"
export * from "./ReferralAdditionalInfo.vue?vue&type=script&lang=js"
import style0 from "./ReferralAdditionalInfo.vue?vue&type=style&index=0&id=30174f2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30174f2e",
  null
  
)

export default component.exports